import React from "react";
import { Button } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";

class AppMainButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  propButtonWidth() {
    return this.props.buttonWidth;
  }

  propButtonWidth() {
    return this.props.buttonWidth;
  }

  stateIsWithArrow() {
    return !this.props.isWithoutArrow;
  }

  getStyles() {
    let style = {
      backgroundColor: 'rgba(218, 41, 28, 0.5)',
      color: "#FFFFFF",
      borderRadius: "12px",
      height: "44px",
      fontSize: "16px",
      paddingLeft: "30px",
      paddingRight: "30px",
      border: "0px solid transparent",
      width: this.propButtonWidth() || "",
    };

    if (this.props.enable) {
      style = {
        backgroundColor: "#DA291C",
        color: "#FFFFFF",
        borderRadius: "12px",
        height: "44px",
        fontSize: "16px",
        paddingLeft: "30px",
        paddingRight: "30px",
        border: "0px solid transparent",
        width: this.propButtonWidth() || "",
      };
    }

    return style;
  }

  getIconLeftArrowOnStatus() {
    let icon =
      GeneralBloc.getAssetsContextPath() +
      `/assets/icons/ArrowRight_Disable.png`;
    if (this.props.enable) {
      icon =
        GeneralBloc.getAssetsContextPath() + `/assets/icons/LeftArrowWhite.svg`;
    }
    return icon;
  }

  render() {
    return (
      <Button 
      disabled={!this.props.enable}
      onClick={(e) => this.props.onClick(e)} style={this.getStyles()}>
        {" "}
        {this.props.iconBack && (
          <span className="mr-2">
            <img
                
                src={GeneralBloc.getAssetsContextPath() + `/assets/icons/left_white_arrow.svg`}
                alt="New"
                className="mr-2 arrow_left"
              />
          </span>
        )}
        <b>{this.props.label}</b>
        {this.props.icon && (
          <span className="ml-2">
            {this.stateIsWithArrow() ? (
              <img
                src={this.getIconLeftArrowOnStatus()}
                alt="New"
                className="ml-2"
              />
            ) : null}
          </span>
        )}
      </Button>
    );
  }
}

export default AppMainButton;
